'use strict';

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _phpjs = require('phpjs');

var _phpjs2 = _interopRequireDefault(_phpjs);

exports['default'] = {

	Date: function Date(value) {
		if (value) {
			return new _moment2['default'](value).format('D.M.YYYY');
		}
	},

	DateTime: function DateTime(value) {
		if (value) {
			return new _moment2['default'](value).format('D.M.YYYY H:mm');
		}
	},

	Number: function Number(value) {
		if (value !== null) {
			var match = ('' + value).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
			if (!match) {
				return _phpjs2['default'].number_format(value, 0, ',', ' ');
			}
			var places = Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
			return _phpjs2['default'].number_format(value, places, ',', ' ');
		}
	},

	Check: function Check(val) {
		var cn = val ? 'fa fa-check' : 'fa fa-close';
		return _react2['default'].createElement(
			'div',
			{ style: { textAlign: 'center' } },
			_react2['default'].createElement('span', { style: { color: '#444', fontSize: 13 }, className: cn })
		);
	},

	coloredCheck: function coloredCheck(val) {
		var cn = val ? 'fa fa-check' : 'fa fa-close';
		return _react2['default'].createElement(
			'div',
			{ style: { textAlign: 'center' } },
			_react2['default'].createElement('span', { style: { color: val ? '#484' : '#800', fontSize: 13 }, className: cn })
		);
	},

	DbInfo: function DbInfo(value) {
		var _this = this;

		if (typeof value !== 'undefined' || value !== null) {
			var v;
			_Object$keys(this).forEach(function (key) {
				if (_this[key].id == value) {
					v = _this[key].title;
				}
			});
			return v;
		}
	}
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/Renderers.js
 ** module id = 168
 ** module chunks = 2
 **/